import { apiGet, apiPost } from "@/shared/api";

/** Che fine fa la merce di un ordine partito e tornato (o rimborsato). */
export type Esito = "fornitore" | "magazzino" | "buttata" | "cliente";

export const ESITI: ReadonlyArray<{ id: Esito; label: string }> = [
  { id: "fornitore", label: "Torna al fornitore" },
  { id: "magazzino", label: "In magazzino" },
  { id: "buttata", label: "Buttata" },
  { id: "cliente", label: "La tiene il cliente" },
];

export const nomeEsito = (e: Esito): string => ESITI.find((x) => x.id === e)?.label ?? e;

export interface DaDecidere {
  order_id: number;
  reference: string;
  channel: string;
  data: string | null;
  /** Prodotto + imballo pagati (il server può mandarlo come testo); null senza margine. */
  costo: number | string | null;
  proposta: Esito | null;
  perche: string;
}

export interface StatoEsito {
  order_id: number;
  stato: "da_decidere" | "deciso" | "non_serve";
  esito: Esito | null;
  proposta: Esito | null;
  perche: string;
  scelto_da: string;
  scelto_il: string | null;
}

const BASE = "/api/esiti-merce";

export const leggiDaDecidere = () => apiGet<DaDecidere[]>(`${BASE}/da-decidere`);

export const leggiEsito = (ordine: string) =>
  apiGet<StatoEsito>(`${BASE}?ordine=${encodeURIComponent(ordine)}`);

/** Salva la scelta. L'ordine si indica per id (elenco) o per riferimento (pagina ordine). */
export const salvaEsito = (ordine: { orderId: number } | { riferimento: string }, esito: Esito) =>
  apiPost<unknown>(
    BASE,
    "orderId" in ordine
      ? { order_id: ordine.orderId, esito }
      : { ordine: ordine.riferimento, esito },
  );
